import { useCallback } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

import { useActionInput } from '../../../context';
import { useActionData } from '../../../hooks';
import { ValidationError } from '../../../lib/validation';

export const useSubmitHandler = () => {
	const action = useActionInput();
	const data = useActionData();
	const { track } = useAnalytics();
	return useCallback(() => {
		if (action.validator) {
			const actionValidation = action.validator.validate(data);

			if (!actionValidation.isValid()) {
				action.onValidationError?.(actionValidation.errors);
				return action.setErrors(actionValidation.errors);
			}
		}

		if (action.isLoadingAttachment) {
			return action.setErrors([new ValidationError('attachment_loading')]);
		}

		action.setErrors([]);

		if (data.recipients?.some((recipient) => recipient.type === 'group')) {
			const groupRecipients = {
				recipients: data.recipients
					.filter((recipient) => recipient.type === 'group')
					.map((recipient) => ({
						groupType: recipient.dimension,
						displayName: recipient.displayName,
						token: recipient.username,
					})),
			};
			track('Recognition Given with Groups', {
				recipients: groupRecipients,
				message: data.text,
			});
		}
		action.onSubmit(data);
	}, [action, data]);
};
